import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import 'firebase/compat/storage';
import 'firebase/compat/firestore';

// Importamos también las versiones modulares
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID
};

// Verificamos si ya hay una app inicializada
let app;
if (firebase.apps.length === 0) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app();
}

// Servicios de Firebase (API de compatibilidad)
const auth = app.auth();
const storage = app.storage();
const firestore = app.firestore();

// Servicios de Firebase (API modular)
const authModular = getAuth(app);
const storageModular = getStorage(app);
const firestoreModular = getFirestore(app);

/**
 * Adaptador para la versión modular de Firestore
 * 
 * Este adaptador permite usar la versión modular de Firestore en componentes
 * que esperan la versión compat, y viceversa.
 */
const getFirestoreAdapter = () => {
  return {
    compat: firestore,
    modular: firestoreModular
  };
};

export { 
  auth, 
  storage, 
  firestore, 
  authModular, 
  storageModular, 
  firestoreModular,
  getFirestoreAdapter
};
